var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPlus = function SvgPlus(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 14C8.85655 14 9.1544 13.7219 9.1544 13.3794V8.64083H13.8517C14.2013 8.64083 14.5 8.34897 14.5 7.99959C14.4982 7.83183 14.4292 7.67147 14.308 7.553C14.1868 7.43453 14.0229 7.36741 13.8517 7.36607H9.1544V2.61981C9.1544 2.27816 8.85655 2.00003 8.5 2.00003C8.33037 1.99842 8.16701 2.06274 8.04567 2.17891C7.92434 2.29507 7.85492 2.45361 7.85261 2.61981V7.36607H3.14827C2.97706 7.36741 2.81323 7.43453 2.692 7.553C2.57077 7.67147 2.50183 7.83183 2.5 7.99959C2.5 8.34897 2.79873 8.64083 3.14827 8.64083H7.85261V13.3794C7.85261 13.7219 8.14345 14 8.5 14Z",
    fill: "white"
  }))));
};
export default SvgPlus;